import { OptionDataInterface } from '../interfaces/option.data.interface';

export enum OFFERS_FILTERS {
    IS_AUTHORIZED = 'badge_is_authorized',
    FREE_DELIVERY = 'badge_free_delivery',
    DELIVERY_24H = 'badge_delivery_24h',
    RATES = 'badge_rates',
    FAST_PAYMENTS = 'badge_fast_payments',
    IN_POST = 'in_post',
    PERSONAL_RECEIPT = 'badge_personal_receipt',
    OPINEO_CERTIFICATE = 'badge_opineo_certificate'
}

export const FILTER_OPTIONS: OptionDataInterface[] = [
    {
        label: 'Autoryzowane sklepy',
        value: OFFERS_FILTERS.IS_AUTHORIZED,
        className: 'gtm_oflt_auth',
        showInline: true,
        icon: 'check-circle',
        group: 'top_filters'
    },
    {
        label: 'Darmowa wysyłka',
        value: OFFERS_FILTERS.FREE_DELIVERY,
        className: 'gtm_oflt_fs',
        showInline: true,
        icon: 'free-delivery',
        group: 'shipping_and_returns'
    },
    {
        label: 'Wysyłka w 24h',
        value: OFFERS_FILTERS.DELIVERY_24H,
        className: 'gtm_oflt_w24',
        showInline: true,
        icon: 'h',
        group: 'shipping_and_returns'
    },
    {
        label: 'Raty',
        value: OFFERS_FILTERS.RATES,
        className: 'gtm_oflt_rt',
        icon: 'database',
        group: 'payments_and_other'
    },
    {
        label: 'Szybkie płatności',
        value: OFFERS_FILTERS.FAST_PAYMENTS,
        className: 'gtm_oflt_fp',
        group: 'payments_and_other'
    },
    {
        label: 'Wysyłka z InPost',
        value: OFFERS_FILTERS.IN_POST,
        className: 'gtm_oflt_ip inpost_icon',
        group: 'shipping_and_returns',
        icon: 'inpost'
    },
    {
        label: 'Odbiór osobisty',
        value: OFFERS_FILTERS.PERSONAL_RECEIPT,
        className: 'gtm_oflt_os',
        group: 'shipping_and_returns',
        icon: 'map-pin'
    },
    {
        label: 'Certyfikat Opineo',
        value: OFFERS_FILTERS.OPINEO_CERTIFICATE,
        className: 'gtm_oflt_co',
        group: 'top_filters',
        icon: 'cert'
    }
];

export const FILTER_GROUPS: OptionDataInterface[] = [
    {
        label: 'Top filtry',
        value: 'top_filters'
    },
    {
        label: 'Wysyłka i zwroty',
        value: 'shipping_and_returns'
    },
    {
        label: 'Płatności i inne usługi',
        value: 'payments_and_other'
    }
];
